import { gql } from '@apollo/client';

export const fragment = gql`
  fragment DealerSettingsFragment on DealerSettings {
    externalCustomerPortalUrl
    ecommerceUrl
    ecommerceBatteryUrl
    ecommerceSmsUrl
  }
`;

export const refreshInstallationDealerSettingsQuery = gql`
  ${fragment}
  query DealerSettings($giid: String!) {
    installation(giid: $giid) {
      dealerSettings {
        ...DealerSettingsFragment
      }
    }
  }
`;

export const refreshDealerSettingsQuery = gql`
  ${fragment}
  query DealerSettings($locale: String, $dealer: String) {
    dealerSettings(locale: $locale, dealer: $dealer) {
      ...DealerSettingsFragment
    }
  }
`;
